import { render, staticRenderFns } from "./quotationTable.vue?vue&type=template&id=1d3869fc&scoped=true"
import script from "./quotationTable.vue?vue&type=script&lang=js"
export * from "./quotationTable.vue?vue&type=script&lang=js"
import style0 from "./quotationTable.vue?vue&type=style&index=0&id=1d3869fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3869fc",
  null
  
)

export default component.exports